import React, {useState} from 'react';
import {Chip, ChipLabel} from '@fupa/fupa-uikit';
import {Emph} from 'app/components/auth/ProfileAuthDialogStyles';
import styled from 'styled-components';

const SmallChip = styled(Chip)`
  &&& {
    height: 1.5rem;
  }
`;

const SmallChipLabel = styled(ChipLabel)`
  &&& {
    align-items: center;
    padding: 0 0.75rem;
    line-height: normal;
  }
`;

const UserStat = ({onStatsClick, count = 0, animationDuration, statName}) => {
  const [active, setActive] = useState(false);

  const delayHandler = () => {
    setActive(false);
    onStatsClick();
  };

  const handleOnChipClick = () => {
    setActive(true);
    setTimeout(delayHandler, animationDuration);
  };

  return (
    <SmallChip onClick={handleOnChipClick} active={active}>
      <SmallChipLabel>
        <span>
          <Emph>{count}</Emph> {statName}
        </span>
      </SmallChipLabel>
    </SmallChip>
  );
};

export {UserStat};
